export default [
    {
        label: '번호',
        field: 'orderNumber',
        sort: true
    },
    {
        label: '제목',
        field: 'title',
        sort: true
    },
    {
        label: '등록일',
        field: 'regDate',
        sort: true
    },
    {
        label: '조회수',
        field: 'view',
        sort: false
    },
];
